<script>
  import { debounce, ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import { LmsUtils } from '../../LMS/utils/LmsUtils';
  import { M } from '../../external';

  export let widget,
    onChange = ignore,
    onRender = ignore;

  let widgetUi = widget.$widget;

  let existingCircles = [];

  let triggerRenderChange = debounce(() => {
    onChange();
    onRender();
  }, 250);

  let init = async () => {
    existingCircles = await LmsUtils.listCircles();
  };

  onMount(() => {
    init();
  });
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>{M.SELECT_CIRCLE}</h5>
    </div>
    <select class="page-select" bind:value={widget.data.circleId} on:change={triggerRenderChange}>
      {#each existingCircles as circle}
        <option value={circle.id}>{circle.name} ({circle.published ? M.PUBLISHED : M.NOT_PUBLISHED})</option>
      {/each}
    </select>
  </div>
</div>
